<template>
  <sh-modal
    label="Manage Subscriptions"
    id="manage-modal"
    modal-height="fit-content"
    modal-width="550px"
    @modal-closed="closeSubscriptionModal"
  >
    <sh-toggle
      v-if="showEmailSubscription.receive_email_new_recommendations"
      style="text-align: left"
      :active="email_subscriptions.receive_email_new_recommendations"
      :key="
        'Receiverecommendations' +
        email_subscriptions.receive_email_new_recommendations
      "
      label="Receive emails when new recommendations are posted"
      @click="setEmailVal('receive_email_new_recommendations')"
    ></sh-toggle>

    <sh-toggle
      v-if="showEmailSubscription.receive_email_new_app_features"
      style="text-align: left"
      :active="email_subscriptions.receive_email_new_app_features"
      :key="
        'Receivefeatures' + email_subscriptions.receive_email_new_app_features
      "
      label="Receive emails when new features are released"
      @click="setEmailVal('receive_email_new_app_features')"
    ></sh-toggle>

    <sh-toggle
      v-if="showEmailSubscription.receive_email_actions_implemented"
      style="text-align: left"
      :active="email_subscriptions.receive_email_actions_implemented"
      :key="
        'Actionimpl' + email_subscriptions.receive_email_actions_implemented
      "
      label="Send me an email when my actions have been implemented in the
        field"
      @click="setEmailVal('receive_email_actions_implemented')"
    ></sh-toggle>
  </sh-modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ManageSubscriptionsModal",
  components: {},
  props: [],
  data() {
    return {};
  },
  mounted() {
    // console.log("Manage Subscriptions component created");
  },
  created() {},
  beforeUnmount() {
    console.log("Manage Subscriptions component destroyed!");
  },
  computed: {
    ...mapGetters([
      "backendURL",
      "email_subscriptions",
      "showEmailSubscription",
    ]),
    ...mapGetters("oidcStore", ["oidcUser"]),
  },
  methods: {
    ...mapActions(["setEmailSubscriptionOptions"]),

    closeSubscriptionModal() {
      document.querySelector("#manage-modal").visible = false;
    },

    setEmailVal(val) {
      this.setEmailSubscriptionOptions(val);
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss"></style>
